<template>
  <div id="pdf-template-dialog" class="text-xs-center">
    <v-dialog v-model="dialog" width="1400" persistent>
      <v-card>
        <v-card-text class="pdf-template-dialog">
          <div class="template-view">
            <PdfTemplatePreview :template="template" />
          </div>
          <div class="template-settings">
            <PdfTemplateInput :template="template" />
          </div>
          <div class="template-components">
            <PdfTemplateTextsTable :template="template" />
            <PdfTemplateBoxesTable :template="template" />
            <PdfTemplateQrCodesTable :template="template" />
            <PdfTemplateImagesTable :template="template" />
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">{{
            $t("pdf_template_dialog.close")
          }}</v-btn>
          <v-btn v-if="editting" color="primary" flat @click="edit">{{
            $t("pdf_template_dialog.edit")
          }}</v-btn>
          <v-btn v-else color="primary" flat @click="save">{{
            $t("pdf_template_dialog.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PdfTemplate from "@/models/PdfTemplate.js";
import PdfTemplateImage from "@/models/PdfTemplateImage.js";
import PdfTemplatePreview from "@/components/admin/PdfTemplatePreview.vue";
import PdfTemplateInput from "@/components/admin/PdfTemplateInput.vue";
import PdfTemplateTextsTable from "@/components/admin/PdfTemplateTextsTable.vue";
import PdfTemplateBoxesTable from "@/components/admin/PdfTemplateBoxesTable.vue";
import PdfTemplateQrCodesTable from "@/components/admin/PdfTemplateQrCodesTable.vue";
import PdfTemplateImagesTable from "@/components/admin/PdfTemplateImagesTable.vue";
export default {
  name: "pdf-template-dialog",
  components: {
    PdfTemplateInput,
    PdfTemplatePreview,
    PdfTemplateTextsTable,
    PdfTemplateBoxesTable,
    PdfTemplateQrCodesTable,
    PdfTemplateImagesTable,
  },
  data() {
    return {
      dialog: false,
      editting: false,
      template: {
        texts: [],
        boxes: [],
        qr_codes: [],
        images: [],
      },
      defaultTemplate: {
        texts: [],
        boxes: [],
        qr_codes: [],
        images: [],
      },
      onKeyUp: (e) => {
        if (e.key === "Escape") {
          this.dialog = false;
        }
      },
    };
  },

  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        this.$emit("updated");
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
  },

  destroyed() {
    document.removeEventListener("keyup", this.keyUpHandler);
  },

  methods: {
    openCreate(template) {
      this.editting = false;
      if (template) {
        this.template = template;
      } else {
        this.template = { ...this.defaultTemplate };
      }
      this.dialog = true;
    },
    openEdit(template) {
      this.template = template;
      this.editting = true;
      this.dialog = true;
    },
    async edit() {
      const response = await this.template.update();
      const responseTemplate = new PdfTemplate(response);
      await PdfTemplateImage.attachImages(responseTemplate, this.template);
      this.$emit("updated");
      this.dialog = false;
    },
    async save() {
      const response = await PdfTemplate.createTemplate(this.template);
      const responseTemplate = new PdfTemplate(response);
      await PdfTemplateImage.attachImages(responseTemplate, this.template);
      this.$emit("updated");
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.pdf-template-dialog {
  position: relative;
  min-height: 800px;
}
.template-view {
  position: absolute;
  top: 20px;
  left: 10px;
  width: calc(30% - 20px);
  height: 400px;
}
.template-settings {
  position: absolute;
  left: 10px;
  width: calc(30% - 20px);
  height: calc(100% - 420px);
  top: 420px;
  padding-right: 10px;
}
.template-components {
  position: absolute;
  top: 20px;
  width: calc(70%);
  height: calc(100% - 20px);
  overflow-y: auto;
  overflow-x: hidden;
  right: 10px;
}
</style>